export default [{
  path: 'myorder/:leftid',
  name: 'merchant_myorder',
  component: () => import('@/views/merchant/admin/workorder/list'),
  meta: {
    tpflag: 'merchant',
    title: '我的工单',
  }
}, {
  path: 'myordernew/:leftid',
  name: 'merchant_myordernew',
  component: () => import('@/views/merchant/admin/workorder/new'),
  meta: {
    tpflag: 'merchant',
    title: '我的工单-新增',
  }
}]



// WEBPACK FOOTER //
// ./src/router/user/_workorder.js